// reducer.js
import * as types from "../actionTypes";

const initialState = {
  data: [],
  isLoading: false,
  message: "",
  status: false,
};

const resumeTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_TEMPLATES_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case types.FETCH_TEMPLATES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        status: action.payload.status,
      };
    case types.FETCH_TEMPLATES_FAILURE:
      return {
        ...state,
        isLoading: false,
        data: [],
        message: action.payload.message,
        status: action.payload.status,
      };
    default:
      return state;
  }
};

export default resumeTemplateReducer;
